// Turns a rejected thunk payload (usually the API's message string) into display text
export const authErrorMessage = (payload: unknown, fallback: string) => {
  if (typeof payload === "string" && payload.trim()) return payload;
  const message = (payload as { message?: unknown } | null)?.message;
  return typeof message === "string" && message.trim() ? message : fallback;
};
